
  export default {
    props: {
      filteredProviders: { type: Array, default: () => [] },
      missingProviders: { type: Array, default: () => [] }
    },
    computed: {
      providers () {
        return this.filteredProviders.length >= 1
          ? this.filteredProviders
          : this.$store.getters['providers/getList'];
      }
    }
  };
